import { Component } from '@angular/core';
import { Capacitor, Plugins } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import {AppService} from "./services/app.service";
import {SessionService} from "./services/session.service";
import {Router} from "@angular/router";
import {AlertController, Platform} from "@ionic/angular";
import { Storage } from '@ionic/storage-angular';
import { Location } from '@angular/common';
const { StatusBar, SplashScreen } = Plugins || {};
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';


import { timer } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
    private _storage: Storage | null = null;
    userId: any
    version:any = 2;
    pushtoken:any = '';
    constructor(private appService: AppService,
              private router: Router,
              private alertCtrl: AlertController,
              private _location: Location,
              private platform: Platform,
              private storage: Storage,
              private mySession: SessionService) {
        this.init();
        this.getDeviceInfo();
        this.checkUser();
        this.checkversion();

        this.mySession.getToken().subscribe((data) => {
            this.pushtoken = data;
            if(this.pushtoken!=undefined) {
              this.set('pushtoken',this.pushtoken);
            }
        });
    }

    async checkUser() {
        this.userId = await this.storage.get('user_id');
        if(!this.userId || this.userId=='' || this.userId==undefined) {
            //this.router.navigate(['/sign-in'])
            console.log(this.userId);
        }
        if (this.platform.is("android") && StatusBar && StatusBar.setOverlaysWebView) {
          StatusBar.setOverlaysWebView({overlay: true});
          StatusBar.setBackgroundColor({color: '#33000000'});
        }
    }

    async init() {
        const storage = await this.storage.create();
        this._storage = storage;
        this.initializeApp();
        if (Capacitor.isNativePlatform()) {
          this.firebase();
        }
    }

    async getDeviceInfo() {
        //const {Device} = Plugins
        //const info = await Device.getInfo();
        //const device_id = info.uuid;
        //this.fetchSubscriptions(device_id);
    }
    
    fetchSubscriptions(device_id) {
        this.appService.post('generatetoken', {device_id})
        .then(async (res: any) => {
          const token = res.token;
          console.log(token, 'token');
            this._storage?.set("ACCESS_TOKEN", res.token);
            this._storage?.set("token", res.token);
        });
    }
    
    checkversion() {
        this.appService.post('getversion',{})
            .then(async (res: any) => {
                if(this.version<res.version) {
                    // this.updateAlert(res.msg,res.url);
                }
            });
    }

    initializeApp() {

        this.platform.ready().then(() => {
            timer(5000).subscribe(()=> {
              if (SplashScreen && SplashScreen.hide) {
                SplashScreen.hide();
              }
            });
        });

        this.platform.backButton.subscribeWithPriority(10, (processNextHandler) => {

            if (this._location.isCurrentPathEqualTo('/home') || this._location.isCurrentPathEqualTo('home/quiz-list')) {

                // Show Exit Alert!

                this.showExitConfirm();
                processNextHandler();
            } else {

                if (this._location.isCurrentPathEqualTo('/quiz-questions')) {
                    
                } else {
                // Navigate to back page

                    this._location.back();
                }
            }

        });

        this.platform.backButton.subscribeWithPriority(5, () => {

            this.alertCtrl.getTop().then(r => {
                if (r) {
                    navigator['app'].exitApp();
                }
            }).catch(e => {
                console.log(e);
            })
        });

    }

    showExitConfirm() {
        this.alertCtrl.create({
            header: 'App termination',
            message: 'Do you want to close the app?',
            backdropDismiss: false,
            buttons: [{
                text: 'Stay',
                role: 'cancel',
                handler: () => {
                    console.log('Application exit prevented!');
                }
            }, {
                text: 'Exit',
                handler: () => {
                    navigator['app'].exitApp();
                }
            }]
        })
        .then(alert => {
            alert.present();
        });
    }

    updateAlert(msg,url) {
        this.alertCtrl.create({
            header: 'Update Available',
            message: msg,
            backdropDismiss: false,
            buttons: [{
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                    console.log('Application exit prevented!');
                }
            }, {
                text: 'Update',
                handler: () => {
                    window.open(url, "_blank");
                }
            }]
        })
        .then(alert => {
            alert.present();
        });
    }

    firebase() {
        if (!Capacitor.isNativePlatform()) {
          return;
        }
        PushNotifications.requestPermissions().then((result) => {
          console.log(result);
          if (result.receive === 'granted') {
            PushNotifications.register();
          } else {
            // Show some error
          }
        });

        PushNotifications.addListener('registration', (token: Token) => {
          // Push Notifications registered successfully.
          // Send token details to API to keep in DB.
          console.log(JSON.stringify(token.value));
          this.set("pushtoken", JSON.stringify(token.value));
          this.mySession.myToken(JSON.stringify(token.value));
        });

        PushNotifications.addListener('registrationError', (error: any) => {
          console.log(error);
          // Handle push notification registration error here.
        });

        PushNotifications.addListener(
          'pushNotificationReceived',
          (notification: PushNotificationSchema) => {
            //alert(JSON.stringify(notification));
            // Show the notification payload if the app is open on the device.
          }
        );

        PushNotifications.addListener(
          'pushNotificationActionPerformed',
          (notification: ActionPerformed) => {
            //alert(JSON.stringify(notification));
            // Implement the needed action to take when user tap on a notification.
          }
        );
    }


    public set(key: string, value: any) {
        this._storage?.set(key, value);
    }
}
